import { Landmark, HeartHandshake, Building2, ShieldCheck, KeyRound } from "lucide-react";
import { CLIENTS } from "@/data";
import { Reveal, Eyebrow } from "@/components/site/Reveal";

const ICONS = { Landmark, HeartHandshake, Building2, ShieldCheck, KeyRound };
const IMG = "/work-1-cw.webp";

const STATS = [
  { v: "24/7", l: "Responsive attendance" },
  { v: "VIC + NSW", l: "Service coverage" },
];

export default function Trust() {
  return (
    <section
      id="trust"
      data-testid="trust-section"
      className="scroll-mt-20 border-t border-[#2a2a2a] bg-[#050505] py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-10">
          <div className="md:col-span-6">
            <Reveal><Eyebrow>Who we work with</Eyebrow></Reveal>
            <Reveal i={1}>
              <h2 className="mt-4 font-display text-4xl font-semibold leading-[1.02] tracking-tighter text-[#f5f5f0] sm:text-5xl">
                Trusted by the people who manage risk.
              </h2>
            </Reveal>
            <Reveal i={2}>
              <p className="mt-5 max-w-lg text-base leading-relaxed text-[#8a8a8a]">
                We support organisations and individuals with clear
                communication and practical guidance — from first assessment
                right through to handover.
              </p>
            </Reveal>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2">
              {CLIENTS.map((c, i) => {
                const Icon = ICONS[c.icon];
                return (
                  <Reveal
                    key={c.label}
                    i={i}
                    className="group flex items-center gap-4 border-b border-[#1a1a1a] py-5"
                  >
                    <Icon
                      className="h-6 w-6 text-[#c4a962] transition-transform duration-300 group-hover:-translate-y-1"
                      strokeWidth={1.6}
                    />
                    <span className="font-display text-lg tracking-tight text-[#f5f5f0]">
                      {c.label}
                    </span>
                  </Reveal>
                );
              })}
            </div>
          </div>

          <div className="md:col-span-6">
            <Reveal i={1} className="overflow-hidden border border-[#2a2a2a]">
              <img
                src={IMG}
                alt="Property make-safe and restoration works"
                className="aspect-[4/5] w-full object-cover grayscale transition-all duration-700 hover:grayscale-0"
              />
            </Reveal>
            <div className="mt-px grid grid-cols-2 gap-px bg-[#2a2a2a]">
              {STATS.map((s) => (
                <div key={s.l} className="bg-[#050505] p-5">
                  <div className="font-display text-2xl font-semibold tracking-tight text-[#f5f5f0] md:text-3xl">
                    {s.v}
                  </div>
                  <div className="mt-1 text-xs uppercase tracking-wide text-[#8a8a8a]">
                    {s.l}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
